import * as React from 'react';
import { SVGProps } from 'react';

const IconDocAddSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.56 4.354a1.5 1.5 0 0 1 .44 1.06V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h5.586a1.5 1.5 0 0 1 1.06.44l3.915 3.914zM9.5 5h3.293L9 1.207V4.5a.5.5 0 0 0 .5.5zM9 13v-2H7v-1h2V8h1v2h2v1h-2v2H9z"
    />
  </svg>
);
export default IconDocAddSizeS;
